import React from "react";
import {controlPropTypes} from "../formhelpers";
import PropTypes from "prop-types";

export default class Checkbox extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    convertBoolToValue(value) {
        const config = this.props.descriptor.config || {};
        if(value) {
            return config.checkedValue !== undefined ? config.checkedValue : true;
        }
        return config.uncheckedValue !== undefined ? config.uncheckedValue : false;
    }

    convertValueToBool(value) {
        const config = this.props.descriptor.config || {};
        const checkedValue = config.checkedValue !== undefined ? config.checkedValue : true;
        return value === checkedValue;
    }

    onChange(e) {
        const { descriptor, onCommitChange, value, enabled, onChange } = this.props;
        const newValue = this.convertBoolToValue(e.target.checked);
        if(enabled) {
            if(newValue !== value) {
                onCommitChange && onCommitChange(descriptor, newValue);
            }
        }
        onChange && onChange(e, descriptor, newValue);
    }

    onKeyDown(e) {
        const {descriptor, onKeyDown} = this.props;
        onKeyDown && onKeyDown(e, descriptor, this.convertBoolToValue(e.target.checked), false);
    }

    onClick(e) {
        const { descriptor, onClick } = this.props;
        onClick && onClick(e, descriptor, this.convertBoolToValue(e.target.checked));
    }

    onFocus(e) {
        const { descriptor, onFocus } = this.props;
        onFocus && onFocus(e, descriptor, this.convertBoolToValue(e.target.checked));
    }

    onBlur(e) {
        const { descriptor, onBlur } = this.props;
        const value = this.convertBoolToValue(e.target.checked);
        onBlur && onBlur(e, descriptor, value);
    }

    render() {
        const { enabled, value } = this.props;

        return (<input
            type="checkbox"
            className="focusable"
            onChange={this.onChange}
            checked={this.convertValueToBool(value)}
            onClick={this.onClick}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onKeyDown={this.onKeyDown}
            disabled={!enabled}
        />);
    }
}

Checkbox.propTypes = controlPropTypes({
    copyOnClickMappings: PropTypes.arrayOf(
        PropTypes.shape({
            source: PropTypes.string.isRequired,
            target: PropTypes.string.isRequired,
        })
    ),
    checkedValue: PropTypes.oneOfType([PropTypes.string,PropTypes.bool]),
    uncheckedValue: PropTypes.oneOfType([PropTypes.string,PropTypes.bool]),
});




// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/Checkbox.js